function Recorder(app, stream) {

	this.p = app;
	this.recorderRTC;
	this.fileBasePath = dirname + "/videos/"
	this.recordBtn = $('#btn-record-webm');
	this.recordCounter = $('#record-button-container .counter');

	this.recording = false;

	this.recordDuration = 5;

	this.recorderRTC = RecordRTC(stream, {
		type: 'video'
	});

	this.init();
}

Recorder.prototype.init = function () {
	// this.captureCanvas = this.p.world.capture.domElement;


	this.recordBtn.on("click", $.proxy(this.startRecording, this));

	if (typeof nw !== "undefined") {
		// check if videos folder exists, if not create it
		if (!fs.existsSync(this.fileBasePath)) {
			fs.mkdirSync(this.fileBasePath);
		}
	}
}


Recorder.prototype.startRecording = function () {

	if (this.recording) {
		return false;
	}

	this.recording = true;

	console.log("start recording");
	this.recordCounter.text(this.recordDuration - 1);

	var tween = TweenMax.fromTo($("#overlay"), 1, {
		opacity: 1
	}, {
		opacity: 0,
		ease: Power3.easeOut,
		onComplete: $.proxy(function () {

			this.recorderRTC.startRecording();

			// counter animation
			var counter = this.recordDuration - 1;

			var recordInterval = setInterval($.proxy(function () {
				this.recordCounter.text(counter - 1);
				var tl = new TimelineLite();
				tl.to(this.recordCounter, 0.15, {
					scale: 1.25,
					ease: Back.easeOut
				}).to(this.recordCounter, 0.15, {
					scale: 1,
					ease: Back.easeOut,
					onComplete: $.proxy(function () {
						counter--;

						if (counter == 0) {
							this.stopRecording();
							clearInterval(recordInterval);
						}
					}, this)
				});

			}, this), 1000);


			// setTimeout($.proxy(function () {
			// 	this.stopRecording();
			// }, this), this.recordDuration * 1000);
		}, this)
	});

	$('body').addClass("recording");

	var tween = TweenMax.fromTo(this.recordCounter, 0.25, {
		opacity: 0,
		scale: 0
	}, {
		opacity: 1,
		scale: 1,
		ease: Back.easeOut,
		delay: 0.75
	})


}

Recorder.prototype.stopRecording = function () {

	this.recorderRTC.stopRecording($.proxy(function (url) {
		if (typeof nw !== "undefined") {
			this.saveRecording(this.recorderRTC.getBlob());
		} else {
			console.log("success");
			console.log(this.recorderRTC.getBlob());
			this.p.recordingCompleted(0);
			this.cleanRecorder();
		}

		$('body').removeClass("recording");

		var tween = TweenMax.fromTo($("#overlay"), 1, {
			opacity: 1
		}, {
			opacity: 0,
			ease: Power4.easeOut
		});

		var tween = TweenMax.fromTo(this.recordCounter, 0.25, {
			opacity: 1,
			scale: 1
		}, {
			opacity: 0,
			scale: 0,
			ease: Back.easeIn
		})

	}, this));

}

Recorder.prototype.saveRecording = function (blob) {
	console.log("save recording")

	this.blobToBase64(blob, $.proxy(function (base64) {
		var currentVideo = parseInt(localStorage.getItem(localStorageName)) + 1;

		var filename = "video" + currentVideo + ".webm";

		// here we should check localstorage to check which file # we are at, and then increment it

		var fileBuffer = new Buffer(base64, "base64");

		fs.writeFile(this.fileBasePath + filename, fileBuffer, $.proxy(function (err) {
			if (err) {
				console.log("err", err);
			} else {
				console.log("success");
				this.p.recordingCompleted(currentVideo);
				this.cleanRecorder();
				fileBuffer = null;
			}
		}, this));
	}, this));

}

Recorder.prototype.cleanRecorder = function () {
	console.log("clean")

	this.recorderRTC.clearRecordedData();   // FIXED
}


Recorder.prototype.blobToBase64 = function (blob, callback) {
	var reader = new FileReader();
	reader.onload = function () {
		var dataUrl = reader.result;
		var base64 = dataUrl.split(',')[1];
		callback(base64);
	};
	reader.readAsDataURL(blob);
};

// Expose App
window.Recorder = Recorder;